import { darken } from 'polished';
import styled, { css } from 'styled-components';

// responder a mensagem do whatsapp
export const ReplyIconContainerClient = styled.div`
  position: absolute;
  right: -2.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  cursor: pointer;

  &:hover {
    color: #007bff;
  }
`;

export const MessageHoverContainerClient = styled.div`
  width: 100%;

  position: relative;

  &:hover ${ReplyIconContainerClient} {
    display: block;
  }
`;

export const ReplyIconContainerUser = styled.div`
  position: absolute;
  left: -2.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  color: #525f7f;
  cursor: pointer;

  svg {
    transform: scaleX(-1);
  }

  &:hover {
    color: #007bff;
  }
`;

export const ChatBallonResponseReply = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 5px;
  cursor: pointer;
  height: 60px;
  padding: 10px 0px;
  background-color: ${(props) => {
    try {
      const darkenedColor = darken(0.06, props.backgroundColor);
      return darkenedColor;
    } catch (error) {
      console.error('Invalid color format:', props.backgroundColor);
      return props.backgroundColor;
    }
  }};
  margin-bottom: 4px;
  justify-content: space-between;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    border-radius: 5px;
    min-height: 100%;
    width: 0.3rem;
    height: 60px;
    background-color: ${(props) => props.color};
  }
`;

export const ReplyIcon = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ReplyContent = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
`;

export const ReplyContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '60%')};
  margin-left: 10px;
  padding-right: ${({ isFullWidth }) => (isFullWidth ? '10px' : '0px')};
  justify-content: center;
  align-items: flex-start;

  & > div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
  }
`;

export const ReplyImagePreview = styled.div`
  width: 40%;
  height: 60px;
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  margin-left: 10px;
`;

export const ReplyVideoPreview = styled.div`
  width: 40%;
  height: 60px;
  border-radius: 5px;
  margin-left: 10px;
`;

export const ReplyStickerPreview = styled.div`
  width: 70%;
  margin-left: 15%;
  height: 60px;
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  align-self: center;
`;

export const ReplyTextPreview = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin-left: 10px;
  justify-content: center;
  align-items: flex-start;
`;

export const ReplySender = styled.div`
  display: flex;
  font-weight: bold;
  width: 100%;
  justify-self: flex-start;
  ${(props) => props.color && `color: ${props.color};`}
`;

export const ReplyText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) => props.color && `color: ${props.color};`}
  max-width: 100%;
`;

//any-message
//any-message:after
export const ClientContent = styled.div`
  position: relative;
  transition: background-color 0.3s ease-in-out;
  margin-left: 20px;
  margin-bottom: 20px;
  padding: 10px 10px 30px 10px;
  background-color: #dbdbdb;

  width: fit-content;
  min-width: 200px;
  white-space: pre-wrap;
  max-width: 60%;
  /* min-height: 100px; */
  font-weight: 400;
  text-align: left;
  border-radius: 10px;

  .g4-link {
    word-wrap: break-word;
  }

  ${(props) =>
    props.highlighted &&
    css`
      background-color: ${darken(0.2, '#dbdbdb')};
      transition: background-color 0.3s ease-in-out;
    `}

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 15px solid
      ${(props) => (props.highlighted ? darken(0.2, '#dbdbdb') : '#dbdbdb')};
    transition: border-top 0.3s ease-in-out;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    top: 0;
    left: -15px;
  }
`;

//.message-content
export const MessageContent = styled.div`
  width: 100%;
  word-break: break-word;
`;

//.any-timestamp
export const ClientTimestamp = styled.div`
  position: absolute;
  font-size: 0.85em;
  font-weight: 400;
  bottom: 5px;
  right: 10px;
  white-space: normal;
`;

//.any-name
export const ClientName = styled.div`
  margin-bottom: 5px;
  font-weight: 600;
`;

//.user-timestamp
export const UserTimestamp = styled.div`
  position: absolute;
  font-size: 0.85em;
  font-weight: 400;
  bottom: 5px;
  right: 10px;
  white-space: normal;
`;

//.user-name
export const UserName = styled.div`
  margin-bottom: 5px;
  font-weight: 600;
`;

//.image-content
export const ImageContent = styled.div`
  text-align: center;
  justify-content: center;

  & + div {
    margin-top: 10px;
  }
`;

//.user-message
//.user-message:after
export const UserContent = styled.div`
  ${(props) => props.color && `background-color: ${props.color};`}
  transition: background-color 0.3s ease-in-out;
  position: relative;
  margin-bottom: 20px;
  margin-left: calc(100% - 62%);
  margin-right: 15px;
  align-self: flex-end;

  padding: 10px 10px 30px 10px;
  color: white;
  white-space: pre-wrap;
  width: fit-content;
  min-width: 200px;

  font-weight: 400;
  /* min-height: 100px; */
  text-align: left;
  border-radius: 10px;

  ${ImageContent} {
    margin-left: auto;
    margin-right: 20px;
  }

  ${(props) =>
    props.highlighted &&
    css`
      background-color: ${darken(0.2, props.color)};
      transition: background-color 0.3s ease-in-out;
    `}

  &:after {
    ${(props) =>
      props.color &&
      css`
        border-bottom: 15px solid
          ${props.highlighted ? darken(0.2, props.color) : props.color};
      `}
    transition: border-bottom 0.3s ease-in-out;
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    color: white;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    bottom: 0;
    right: -15px;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    min-height: 100%;
    width: calc(100% + 50rem);
    height: 60px;
    right: 100%;
  }

  .g4-link {
    word-wrap: break-word;
  }

  &:hover ${ReplyIconContainerUser} {
    display: block;
  }
`;

//  ${(props) => (props.resizable ? console.log('true') : console.log('false'))}

export const ContextMessageContent = styled.div`
  width: 100%;
  background-color: #d1d1d1;
  /* background-color: red; */
  word-break: break-word;
  margin-bottom: 4px;
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  display: flex;

  /* &:before {
    content: '';
    position: absolute;
    background-color: green;
    border-radius: 50%;
    width: 2px;
    height: 100%;
    padding: 1rem 0;
    bottom: 0;
    left: 0;
  } */
`;

export const ContextImageContent = styled.div`
  width: 100%;
  text-align: start;
  justify-content: center;
`;
export const Bar = styled.div`
  margin: -10px 10px -10px -10px;
  border-radius: 5px;
  min-height: 100%;
  width: 0.3rem;
  background-color: #9747ff;
`;

//.image
export const Image = styled.img`
  text-align: center;
  justify-content: center;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 400px;
  cursor: pointer;
`;
export const ContextImage = styled.img`
  text-align: center;
  justify-content: center;
  max-width: 10%;
  max-height: 10%;
  cursor: pointer;
`;

//.message-text
export const MessageText = styled.div`
  cursor: pointer;

  a {
    text-decoration: underline;
  }

  .messagePdf {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ContentContact = styled.div`
  //cursor: pointer;
  //background-color: #c0c0c0;
  //border-radius: 6px;
  padding: 6px;

  > button {
    width: 100%;
    margin-top: 1rem;
    padding: 4px;
    //border: 2px solid #fcfcfc;
    ${(props) => props.color && `border: 1px solid ${props.color};`}

    ${(props) => props.color && `color: ${props.color};`}
    background-color: transparent;
    //color: #fcfcfc;
    border-radius: 4px;

    font-size: 10px;
    font-weight: bold;
    transition: background-color, color, 0.2s;
  }

  > button:hover {
    ${(props) => props.color && `background-color: ${props.color};`}
    color: #fcfcfc;
  }
`;

export const InfoContact = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;

  > div {
    display: flex;
    flex-direction: column;
  }
`;

export const ContentModalInfoContato = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-style: italic;

  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    border-bottom: 1px solid #ccc;
    padding: 12px 0;
  }

  .contact-name {
    font-weight: bold;
  }
`;
